import React, { useEffect, useState } from 'react';
import { GoogleMapAPI } from '../constant';

  function SetInfoWindowData(loc) {
    var HTML = `
     <div>
       <h6 class="mt-2 mb-2 font-weight-bold" align="center" >${loc.Name}</div>
       <div class="mb-2" align="center">${loc.Address}</div>
        <h6 class="mt-2 mb-2 text-primary font-weight-bold ${loc.Phone == undefined || loc.Phone == null ? 'd-none' : ''}" align="center"><img src="../../server-build/Images/phone-icon.png" alt="" class="pe-2"><a href="tel:${loc.Phone}">${loc.Phone}</a></h6>
        <div align="center">In stores now:</div>
       <div class="mt-2 mb-1" align="center">
           ${SetProductImageTemplate(loc.Products)}
       </div>
       <a  align="center" href="https://maps.google.com/?q= ${loc.Lat},${loc.Lng}&z=16" target="_blank"><div class="mt-2 mb-1 small font-weight-bold">View on google map</div></a>
     </div>`;

    return HTML;
}


function SetProductImageTemplate(Products) {
    
    var HTML = "";

    if (Products != null) {
        for (var i = 0; i < Products.length; i++) {
            HTML += '<span class="pe-1"><a href="#" title=' + Products[i].ProductName + '><span><img style="max-height:20px; width:auto" src=' + ' https://publicapi.freshmanager.in/StoreLocator/Product_GetIcon?ProductID=' + Products[i].ProductID + '&APIKey=68a3b7b3-0cd6-4c6b-825e-1f58ad449422' + '' + ' alt="Icon"></span></a></span>';
        }
    }
    return HTML;
}

let map;
let Markers = []; 

function GoogleMaps(props) {   
     
    var pos = {
        lat: 28.610001,
        lng: 77.230003,
    };   

      let  InitMap = (Locations) => { 
         var bounds = new window.google.maps.LatLngBounds();
        var infowindow = new google.maps.InfoWindow({ maxWidth: 350 });
        var marker;
    
        for (var i = 0; i < Markers.length; i++) {
            Markers[i].setMap(null);
        }
        Markers = [];        
        for (var i = 0; i < Locations.length; i++) {
            var loc = Locations[i];
            bounds.extend(new google.maps.LatLng(loc.Lat, loc.Lng));
            
            marker = new google.maps.Marker({
                map: map,
                position: new google.maps.LatLng(loc.Lat, loc.Lng)                
            });    
            Markers.push(marker);
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.setContent(SetInfoWindowData(Locations[i]));
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }      
       map.fitBounds(bounds);
    }   
    

    let onScriptLoad = () => {    
        map = new window.google.maps.Map(document.getElementById("GoogleMap"), {
        center: new google.maps.LatLng(pos.lat, pos.lng),
        zoom: 13,
        disableDefaultUI: true,
        zoomControl: true,
        });
        map.setCenter(pos);       
      }
  
    
    useEffect(() => {       
       
        if (window.google) {
             onScriptLoad();   
             map.addListener("drag", () => {
                props.handleEevent(map.getCenter());
            });           
          } 
      }, []);


      if(props.Coordinates.length > 0) {
        InitMap(props.Coordinates); 
      }
  

    
   return (     
        <div  id="GoogleMap"  className='where-To-Buy-Map' />           
    );
}

export default GoogleMaps; 